import React, {useState} from "react";
import {IconButton, Popover, Tooltip, Typography} from "@mui/material";
import {Apps, KeyboardBackspace} from "@mui/icons-material";
import css_buttons from "../components/Common/css/CCButton.module.scss";
import {useNavigate} from "react-router-dom";
import enterpriseObjectClassFactory from "../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../eoec/eo/EnterpriseObject";
import DeveloperSubscriptionTableApplet from "../eoec/applet/impl/SubscriptionManagement/DeveloperSubscriptionTableApplet";
import DeveloperSubscriptionCommunicationTableApplet from "../eoec/applet/impl/SubscriptionManagement/DeveloperSubscriptionCommunicationTableApplet";
import DeveloperMenu from "../components/Navigation/DeveloperMenu";


type MenuSelection = {id: string, target: EventTarget & HTMLButtonElement, option: string | null}

export default function DashboardSubscriptionManagement() {
    const [developerSubscriptionEnterpriseObject] = useState(() => enterpriseObjectClassFactory("DeveloperSubscription") as EnterpriseObject);
    const [menu, setMenu] = React.useState<MenuSelection | null>(null);

    const navigate = useNavigate();

    function renderContent() {
        return (
            <>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "50px", backgroundColor: "#FFFFFF", borderBottom: "1px solid #EDEFF3"}}>
                    <div style={{display: "flex", flexDirection: "row", paddingTop: "9px", marginLeft: "20px", width: "300px"}}>
                        <IconButton
                            className={css_buttons.whiteStandardButton} style={{marginLeft: "-20px", marginTop: "-2px", cursor: "pointer"}} size="small"
                            onClick={() => {
                                navigate("/dashboard");
                            }}>
                            <KeyboardBackspace sx={{color: "#1498D8", width: "30px", height: "30px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: 20, fontWeight: 500, color: "#1498D8", marginTop: "3px"}}>Subscriptions</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "column", backgroundColor: "#FFFFFF", paddingRight: "60px"}}>
                    <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                        <DeveloperSubscriptionTableApplet enterpriseComponent={developerSubscriptionEnterpriseObject.getEnterpriseComponent("DeveloperSubscription")} />
                    </div>
                    <div style={{paddingLeft: "30px", paddingTop: "30px", width: "100%"}}>
                        <DeveloperSubscriptionCommunicationTableApplet enterpriseComponent={developerSubscriptionEnterpriseObject.getEnterpriseComponent("DeveloperSubscriptionCommunication")} />
                    </div>
                </div>
            </>
        );
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Dashboard</Typography>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginRight: "15px"}}>
                    <Tooltip title={"Administration Menu"}>
                        <IconButton className={css_buttons.blueIconButton2} style={{marginTop: "11px"}} onClick={(e) => setMenu({id: "administrationAppsMenu", target: e.currentTarget, option: null})}>
                            <Apps/>
                        </IconButton>
                    </Tooltip>
                    {menu?.id === "administrationAppsMenu" ? (
                        <Popover anchorEl={menu.target}
                                 anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                                 transformOrigin={{vertical: -11, horizontal: "left"}}
                                 open={true}
                                 onClose={() => setMenu(null)}
                                 TransitionProps={{
                                     onExited: () => setMenu(null),
                                 }}
                                 PaperProps={{
                                     elevation: 2,
                                 }}
                        >
                            <DeveloperMenu/>
                        </Popover>
                    ) : null}
                </div>
            </div>
            {renderContent()}
        </div>
    );
}